import useFetch from 'use-http';
import { getUTMParameters } from '~/utils/utm-tracking-v2';

const useFormSubmit = ({ url, setIsSubmitted }) => {
  const { post, error, response, loading } = useFetch(url);

  return {
    error,
    response,
    loading,
    post: async values => {
      const isBrowser = typeof window !== 'undefined';
      const pagePath = isBrowser ? window.location.pathname : null;

      let data = {
        ...values
      };

      data.user = {
        ...data.user,
        ...getUTMParameters(),
        source: pagePath
      };

      let r = await post(data);
      if (response.ok === true && typeof setIsSubmitted === 'function') {
        setIsSubmitted(true);
      }

      if (typeof window?.dataLayer?.push !== 'undefined') {
        window.dataLayer.push({ event: 'form-submit', pageUrl: pagePath });
      }

      return r;
    }
  };
};

export default useFormSubmit;
